import { ref, computed, getCurrentInstance } from 'vue';
import store from '@/store';
import { config } from '@/config';

export const SPAIN_ID = 68;

const paises = ref([]);
const provincias = ref([]);
const localidades = ref([]);
const loadedPaisId = ref(null);
const loadedProvinciaId = ref(null);

export function useUbicacion() {
    const instance = getCurrentInstance();
    const toast = instance?.proxy.$toast;

    const loadingPaises = ref(false);
    const loadingProvincias = ref(false);
    const loadingLocalidades = ref(false);

    const paisId = ref(null);
    const provinciaId = ref(null);
    const localidadId = ref(null);

    const esEspana = computed(() => paisId.value === SPAIN_ID);

    const cargarPaises = async() => {
        if (paises.value.length > 0) return;

        loadingPaises.value = true;
        try {
            const res = await store.dispatch(config.getVuexAlias('select.paises'));
            paises.value = res.data.data;
        } catch (err) {
            toast?.error(err.message);
        } finally {
            loadingPaises.value = false;
        }
    };

    const cargarProvincias = async id => {
        if (!id) {
            provincias.value = [];
            loadedPaisId.value = null;
            return;
        }

        if (id === loadedPaisId.value && provincias.value.length > 0) return;

        loadingProvincias.value = true;
        provincias.value = [];
        try {
            const res = await store.dispatch(
                config.getVuexAlias('select.provincias'),
                { filters: { pais_id: id } }
            );
            provincias.value = res.data.data;
            loadedPaisId.value = id;
        } catch (err) {
            toast?.error(err.message);
        } finally {
            loadingProvincias.value = false;
        }
    };

    const cargarLocalidades = async id => {
        if (!id) {
            localidades.value = [];
            loadedProvinciaId.value = null;
            return;
        }

        if (id === loadedProvinciaId.value && localidades.value.length > 0) return;

        loadingLocalidades.value = true;
        localidades.value = [];
        try {
            const res = await store.dispatch(
                config.getVuexAlias('select.locations'),
                { filters: { provincia_id: id } }
            );
            localidades.value = res.data.data;
            loadedProvinciaId.value = id;
        } catch (err) {
            toast?.error(err.message);
        } finally {
            loadingLocalidades.value = false;
        }
    };

    const seleccionarPais = async id => {
        paisId.value = id;
        provinciaId.value = null;
        localidadId.value = null;
        provincias.value = [];
        localidades.value = [];
        if (id === SPAIN_ID) await cargarProvincias(id);
    };

    const seleccionarProvincia = async id => {
        provinciaId.value = id;
        localidadId.value = null;
        localidades.value = [];
        await cargarLocalidades(id);
    };

    const seleccionarLocalidad = id => {
        localidadId.value = id;
    };

    const inicializar = async(initPaisId, initProvinciaId, initLocalidadId) => {
        await cargarPaises();
        paisId.value = initPaisId ?? null;

        if (initPaisId === SPAIN_ID) {
            await cargarProvincias(initPaisId);
            provinciaId.value = initProvinciaId ?? null;
        }

        if (initPaisId === SPAIN_ID && initProvinciaId) {
            await cargarLocalidades(initProvinciaId);
            localidadId.value = initLocalidadId ?? null;
        }
    };

    return {
        paises,
        provincias,
        localidades,
        loadingPaises,
        loadingProvincias,
        loadingLocalidades,
        paisId,
        provinciaId,
        localidadId,
        esEspana,
        cargarPaises,
        seleccionarPais,
        seleccionarProvincia,
        seleccionarLocalidad,
        inicializar,
    };
}
